module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claimList"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._l((_vm.list), function(item) {
    return (_vm.list.length > 0) ? _c('router-link', {
      key: item.order_id,
      staticClass: "claim-item",
      attrs: {
        "to": {
          path: 'claimDetail',
          query: {
            uhid: _vm.uhid,
            order_id: item.order_id
          }
        }
      }
    }, [_c('p', {
      staticClass: "claim-no"
    }, [_vm._v("索赔登记号：" + _vm._s(item.order_id) + " ")]), _vm._v(" "), (item.status == 1) ? _c('p', {
      staticClass: "claim-status"
    }, [_vm._v("索赔受理中")]) : _vm._e(), _vm._v(" "), (item.status == 2) ? _c('p', {
      staticClass: "claim-status"
    }, [_vm._v("索赔成功")]) : _vm._e(), _vm._v(" "), (item.status == 3) ? _c('p', {
      staticClass: "claim-status"
    }, [_vm._v("索赔失败")]) : _vm._e(), _vm._v(" "), (item.status == 1) ? _c('div', {
      staticClass: "claim-icon"
    }) : _vm._e(), _vm._v(" "), (item.status == 2) ? _c('div', {
      staticClass: "claim-icon-success"
    }) : _vm._e(), _vm._v(" "), (item.status == 3) ? _c('div', {
      staticClass: "claim-icon-failed"
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "empty-text"
  }, [_vm._v("您还没有进行任何索赔")])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a157fe7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClaimList.vue
// module id = 841
// module chunks = 1